/* ============================================================
   MOSAIK — PDF EXPORT
   ============================================================ */
(function(){
  // Hands the file to the browser, THEN archives a copy + records the event.
  // Order matters: the visitor's download must never wait on (or be cancelled
  // by) the analytics upload. output('blob') re-serializes the doc, which is
  // why it runs after save() rather than before.
  //
  // mode 'blob' : l'appelant garde le fichier au lieu de le faire télécharger
  // (pièce jointe du formulaire de devis, mosaik-quote.js). Rien n'est archivé
  // dans ce cas : ce PDF-là part PAR le formulaire, et il n'a pas à gonfler le
  // compteur `pdf_generated`, qui compte les exports demandés par le visiteur.
  function _finish(pdf, mode) {
    if (mode === 'blob') return pdf.output('blob');
    pdf.save('mosaik.pdf');
    try {
      if (window.MosaikStats) MosaikStats.pdfGenerated(pdf.output('blob'));
    } catch (e) { /* stats must never break the export */ }
    return null;
  }

  /* Depuis la refonte deux colonnes, le plan (colonne gauche) et le récapitulatif
     (tiroir « Afficher les détails ») ne sont plus dans le même conteneur, et
     chacun vit dans une boîte qui défile — html2canvas ne capturerait qu'une
     partie. On DÉPLACE donc les vrais nœuds dans une boîte hors écran de largeur
     fixe le temps de la capture, puis on les remet exactement à leur place
     (repères insérés avant le déplacement). Déplacer le <canvas> conserve son
     bitmap ; le cloner ne le conserverait pas. */
  function _gather() {
    const parts = ['mosaik-canvas-block', 'mosaik-entrance', 'mosaik-result']
      .map(id => document.getElementById(id)).filter(Boolean);
    const stage = document.createElement('div');
    stage.id = 'mosaik-export-stage';
    const moved = parts.map(el => {
      const anchor = document.createComment('mosaik-export');
      el.parentNode.insertBefore(anchor, el);
      stage.appendChild(el);
      return { el, anchor };
    });
    document.body.appendChild(stage);
    return {
      stage,
      restore: function () {
        moved.forEach(({ el, anchor }) => {
          if (anchor.parentNode) anchor.parentNode.insertBefore(el, anchor);
          if (anchor.parentNode) anchor.parentNode.removeChild(anchor);
        });
        if (stage.parentNode) stage.parentNode.removeChild(stage);
      }
    };
  }

  // Voile « génération en cours » sur la zone du plan, qui est momentanément vide
  // pendant la capture.
  function _veil(on) {
    const host = document.getElementById('mosaik-stage');
    if (!host) return;
    let el = document.getElementById('mosaik-export-veil');
    if (on && !el) {
      el = document.createElement('div');
      el.id = 'mosaik-export-veil';
      el.innerText = (window.mosaik && mosaik.getText) ? mosaik.getText('Generating the PDF…') : '…';
      host.appendChild(el);
    } else if (!on && el && el.parentNode) {
      el.parentNode.removeChild(el);
    }
  }

  async function _toPdf(mode) {
  const { jsPDF } = window.jspdf;
  const margin       = 10;    // marge autour (mm)
  const bottomMargin = 20;    // espace pour le footer (mm)
  const pdf          = new jsPDF('p', 'mm', 'a4');
  const pageW        = pdf.internal.pageSize.getWidth();
  const pageH        = pdf.internal.pageSize.getHeight();

  // 1) Capture entière du plan + récap en canvas
  // Le zoom écran est une transformation CSS sur le <canvas> : html2canvas la
  // reproduirait (plan rogné / hors cadre dans le PDF). On revient à 1:1 avant
  // la capture. Le CADRAGE ne dépend donc plus du zoom ; la définition du bitmap,
  // elle, peut être restée celle d'un zoom profond (voir renderScale dans
  // mosaik-render.js) — c'est sans effet ici, sinon une capture un peu plus fine.
  if (window.MosaikZoom) MosaikZoom.reset();
  if (window.MosaikUI) MosaikUI.exporting = true;
  _veil(true);
  const gathered = _gather();
  // Les règles sont posées sur le panneau, en pixels d'écran : le plan vient de
  // changer de boîte (celle, fixe, de la capture), il faut les y refaire — sinon
  // le PDF porte des graduations calculées pour l'écran d'avant.
  if (window.mosaik && mosaik.syncRulers) mosaik.syncRulers();
  let canvas;
  try {
    canvas = await html2canvas(gathered.stage, {
    scale:           1.3,
    backgroundColor: '#fff',
    useCORS:         true,
    allowTaint:      false,
    // Le tableau récap est en `display:inline-block`. Les navigateurs savent le
    // rendre (via des boîtes de table anonymes), mais PAS html2canvas : il dessine
    // le cadre du <table> sans jamais mettre en page les <tr>/<td>, d'où un
    // tableau vide dans le PDF. On force donc `display:table` (rendu de table
    // normal) et on aplatit les décorations « modernes » que html2canvas 1.4.1
    // gère mal — le tout UNIQUEMENT dans le clone de capture, sans rien changer à
    // l'affichage écran.
    onclone: (doc) => {
      // La rangée d'outils posée au-dessus du plan (zoom + le « ? » de l'aide)
      // est DANS #mosaik-canvas-block que _gather() emporte : sans ça elle se
      // retrouverait imprimée sur le devis. Masquée dans le clone uniquement —
      // et masquée EN ENTIER plutôt qu'outil par outil, pour que ce qu'on y
      // ajoutera demain n'ait pas à repasser par ici.
      const topline = doc.getElementById('mosaik-plan-topline');
      if (topline) topline.style.display = 'none';
      // Même raison pour le liseré bleu du panneau : main armée, il dit à
      // l'écran que le dessin est en pause — sur le devis, ce ne serait qu'un
      // cadre bleu inexpliqué autour du plan.
      const pane = doc.getElementById('mosaik-canvas');
      if (pane) pane.classList.remove('mosaik-grab', 'mosaik-grabbing');
      // Les dimensions ne sont plus deux étiquettes autour du plan mais deux
      // règles graduées DESSINÉES SUR LE CANVAS (mosaik-render.js) : html2canvas
      // recopie le canvas tel quel, il n'y a donc plus rien à redresser ici —
      // c'est ce que faisait le rustine writing-mode -> rotate() d'avant.
      const res = doc.getElementById('mosaik-result');
      if (res) res.style.overflow = 'visible';
      const tbl = doc.querySelector('.mosaik-recap-table');
      if (tbl) {
        // Le total est masqué à l'écran (il vit dans le bandeau du bas, voir
        // mosaik-recap.js) mais le devis PDF doit le porter : on le redévoile
        // ICI, dans le clone de capture uniquement.
        const tot = tbl.querySelector('#totalPrice');
        if (tot) { tot.hidden = false; tot.style.display = 'table-row'; }
        tbl.style.display      = 'table';
        tbl.style.margin       = '0 auto';
        tbl.style.overflow     = 'visible';
        tbl.style.boxShadow    = 'none';
        tbl.style.borderRadius = '0';
        // Agrandissement RÉSERVÉ AU PDF : le container entier est mis à l'échelle
        // sur la largeur de la page, donc élargir la table à 80% + grossir la
        // police/les vignettes rend le récap plus grand et lisible dans le PDF,
        // sans toucher à l'affichage écran.
        tbl.style.width        = '80%';
        tbl.style.fontSize     = '1.6em';
        tbl.querySelectorAll('img').forEach(img => {
          img.style.objectFit    = 'fill';
          img.style.borderRadius = '0';
          img.style.width        = '84px';
          img.style.height       = '84px';
        });
      }
    }
    });
  } finally {
    // remise en place systématique : une capture qui échoue ne doit jamais
    // laisser le plan hors écran.
    gathered.restore();
    _veil(false);
    if (window.MosaikUI) MosaikUI.exporting = false;
  }

  const JPEG_QUALITY = 0.75;
  const imgData = canvas.toDataURL('image/jpeg', JPEG_QUALITY);
  const props   = pdf.getImageProperties(imgData);
  // props.width / props.height = dimensions du JPEG en px

  // 2) Calcul des dimensions de l'image dans le PDF (en mm)
  const imgW = pageW - margin * 2;
  const imgH = (props.height * imgW) / props.width;

  // hauteur totale disponible
  const fullH       = pageH - margin * 2;
  const withFooterH = fullH - bottomMargin;

  // 3) Cas « tout tient sur une seule page » (contenu + footer)
  if (imgH <= withFooterH) {
    // 3.a) on place l'image complète
    pdf.addImage(imgData, 'JPEG', margin, margin, imgW, imgH);

    // 3.b) on ajoute le footer
    const footerLines = [
      'MOSAIK CREATION',
      'TVA FR95835038043 – Siret 83503804300013',
      'Tel : +33 (0) 4 81 91 83 74 – Mail : contact@mosaik-floor.fr',
      'www.mosaik-floor.fr'
    ];
    pdf.setFontSize(10);
    footerLines.forEach((line, i) => {
      const y = pageH - margin - (footerLines.length - 1 - i) * 4;
      pdf.text(line, pageW / 2, y, { align: 'center' });
    });

    return _finish(pdf, mode);   // on sort, sans pagination
  }

  // 4) Sinon : découpage en tranches pour plusieurs pages
  // conversion px → mm pour le slicing
  const pxPerMm = props.height / imgH;
  // hauteur de chaque tranche en px
  const slicePx = Math.floor(withFooterH * pxPerMm);
  // nombre de pages nécessaires
  const pageCount = Math.ceil(props.height / slicePx);

  for (let page = 0; page < pageCount; page++) {
    // position en px dans le canvas source
    const yOffsetPx = page * slicePx;
    // hauteur de la tranche (la dernière peut être plus petite)
    const thisSlicePx = (page === pageCount - 1)
      ? props.height - yOffsetPx
      : slicePx;

    // 4.a) création d'un canvas temporaire pour la tranche
    const sliceCanvas = document.createElement('canvas');
    sliceCanvas.width  = props.width;
    sliceCanvas.height = thisSlicePx;
    const sliceCtx = sliceCanvas.getContext('2d');

    // 4.b) on copie la portion correspondante
    sliceCtx.drawImage(
      canvas,
      0,                 // sx
      yOffsetPx,         // sy
      props.width,       // sWidth
      thisSlicePx,       // sHeight
      0,                 // dx
      0,                 // dy
      props.width,       // dWidth
      thisSlicePx        // dHeight
    );

    // 4.c) on génère l'image de la tranche
    const sliceImg  = sliceCanvas.toDataURL('image/jpeg', JPEG_QUALITY);
    const sliceMmH  = (thisSlicePx * imgW) / props.width;

    // 4.d) nouvelle page si nécessaire
    if (page > 0) pdf.addPage();

    // 4.e) on place la tranche
    pdf.addImage(sliceImg, 'JPEG', margin, margin, imgW, sliceMmH);

    // 4.f) footer uniquement sur la dernière page
    if (page === pageCount - 1) {
      const footerLines = [
        'MOSAIK CREATION',
        'TVA FR95835038043 – Siret 83503804300013',
        'Tel : +33 (0) 4 81 91 83 74 – Mail : contact@mosaik-floor.fr',
        'www.mosaik-floor.fr'
      ];
      pdf.setFontSize(10);
      footerLines.forEach((line, i) => {
        const y = pageH - margin - (footerLines.length - 1 - i) * 4;
        pdf.text(line, pageW / 2, y, { align: 'center' });
      });
    }
  }

  // 5) Sauvegarde finale
  return _finish(pdf, mode);
}
  // Les deux entrées passent par le MÊME rendu ; seule la remise du document
  // change. Elles sont enveloppées plutôt que posées telles quelles : branchée
  // directement sur un addEventListener, `export` recevrait l'événement du clic
  // comme mode.
  window.MosaikPdf = {
    export: function () { return _toPdf(); },
    blob:   function () { return _toPdf('blob'); }
  };
})();
